import { useRevalidator } from '@remix-run/react';
import { useEffect } from 'react';

const useRevalidateOnInterval = ({
  enabled,
  interval = 30000,
}: {
  enabled: boolean;
  interval?: number;
}) => {
  const { revalidate } = useRevalidator();

  useEffect(() => {
    if (!enabled) {
      return;
    }
    const intervalId = setInterval(() => revalidate(), interval);
    return () => clearInterval(intervalId);
  }, [enabled, interval, revalidate]);
};

export default useRevalidateOnInterval;
